export const GET_GEARBOX_STAGE_2_RESULT = "GET_GEARBOX_STAGE_2_RESULT";
export const GET_GEARBOX_STAGE_2_RESULT_SUCCESS = "GET_GEARBOX_STAGE_2_RESULT_SUCCESS";
export const GET_GEARBOX_STAGE_2_RESULT_ERROR = "GET_GEARBOX_STAGE_2_RESULT_ERROR";
export const RESET_GEARBOX_STAGE_2_RESULT = "RESET_GEARBOX_STAGE_2_RESULT";
